import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main>
      <div className="pt-20">
        <section className="flex min-h-[70vh] items-center justify-center bg-[#191e1c] px-5 py-20 text-center">
          <div className="section-container max-w-[650px]">
            <p className="font-jakarta text-[12px] font-medium tracking-[0.34em] text-[var(--mint-green)] sm:text-[13px]">
              404 ERROR
            </p>
            <h1 className="mt-4 font-bricolage text-[42px] font-semibold tracking-[-1.5px] text-[#f4f7f5] sm:text-[52px]">
              Page not found
            </h1>
            <p className="mt-4 font-jakarta text-[15px] leading-[1.65] text-[#9fa9a5] sm:text-[16px]">
              The page you are looking for doesn't exist or has been moved.
            </p>
            <div className="mt-8">
              <Link
                to="/"
                className="inline-flex h-[50px] items-center justify-center rounded-full bg-[var(--mint-green)] px-8 font-jakarta text-[15px] font-semibold text-[#071b17] shadow-lg shadow-[var(--mint-green)]/20 transition-all duration-200 hover:brightness-105 hover:-translate-y-0.5"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

